import { Form } from 'antd';
import type { NamePath } from 'rc-field-form/es/interface';

import { OvernightRuleSwitchField } from './OvernightRuleSwitchField';

type OvernightRuleFieldProps = {
  name: NamePath;
  disabled?: boolean;
};

export const OvernightRuleField = ({
  name,
  disabled,
}: OvernightRuleFieldProps) => {
  const form = Form.useFormInstance();

  const isAlwaysIncludedWithNight = Form.useWatch(name, form);

  return (
    <>
      <Form.Item
        name={name}
        rules={[{ required: true, message: 'Required' }]}
        valuePropName="checked"
      >
        <OvernightRuleSwitchField
          value={isAlwaysIncludedWithNight}
          disabled={disabled}
        />
      </Form.Item>
    </>
  );
};
